import { getAuthStore, IAuthStore, IRegisterForm } from './store';
import { IErrorsStore } from '../errors/store';

import api, { request } from '../../api';
import { HIDECOOKIESBANNERCOOKIE } from '../../components/Header/AdminHeader/Components/CookiesBanner/CookiesBanner';
import { IActionGroup, IStore, store as initialStore } from '../index';

export interface ILoginForm {
  email: string;
  password: string;
}

export interface IResetPasswordForm {
  new_password1: string;
  new_password2: string;
  acceptedToS?: boolean;
}

export interface IResetPassword extends IResetPasswordForm {
  uid: string;
  token: string;
}

export interface IAuthActions extends IActionGroup {
  login: (data: ILoginForm) => { auth?: IAuthStore; errors?: IErrorsStore };
  logout: () => { auth: IAuthStore };
  refreshToken: () => { auth: IAuthStore };
  register: (data: any) => { auth?: IAuthStore; errors?: IErrorsStore };
  requestResetPassword: (data: any) => { details?: string; errors?: IErrorsStore };
  resetPassword: (data: IResetPassword) => { details?: string; errors?: IErrorsStore };
}

const login = (token: string): void => {
  localStorage.setItem('auth', JSON.stringify({ isAuthenticated: true, token }));
};

const actions: IActionGroup = {
  login: async (_: IStore, data: ILoginForm) => {
    const response = await request.post(api.login, data);

    if (response.error) {
      return {
        errors: {
          login: {
            msg: response.error.statusText
          }
        }
      };
    }

    const { token, user } = response;
    login(token);

    return {
      auth: { token, isAuthenticated: true },
      user
    };
  },
  logout: async (state: IStore) => {
    const auth = getAuthStore();
    const { token } = auth;
    if (token) {
      const data = { token };
      await request.post(api.logout, data);
    }
    localStorage.removeItem('auth');
    localStorage.removeItem(HIDECOOKIESBANNERCOOKIE);

    return {
      ...initialStore,
      actions: state.actions,
      auth: { isAuthenticated: false, token: '' }
    };
  },
  refreshToken: async (state: IStore) => {
    const response = await request.post(api.refreshToken, { token: state.auth.token });
    if (response.error) {
      return {};
    }

    const { token } = await response;
    login(token);
    return {
      auth: { token, isAuthenticated: true }
    };
  },
  register: async (state: IStore, data: IRegisterForm) => {
    const response = await request.post(api.register, {
      email: data.user.email,
      first_name: data.user.firstName,
      last_name: data.user.lastName,
      password1: data.password1,
      password2: data.password2,
      username: state.invitation.email || data.user.email
    });

    if (response.error) {
      const key = Object.keys(response.error.body)[0];
      return {
        errors: {
          auth: {
            el: key,
            msg: response.error.body[key]
          }
        }
      };
    }

    const { token, user } = response;
    const { email, firstName, lastName, pk: id } = user;
    login(token);
    return {
      auth: { token, isAuthenticated: true },
      user: {
        email,
        firstName,
        id,
        lastName,
        profile: {
          ...state.user.profile
        }
      }
    };
  },
  requestResetPassword: async (state: IStore, data: any) => {
    const response = await request.post(api.requestResetPassword, data);

    if (response.error) {
      return {
        errors: {
          resetPassword: {
            msg: response.error.statusText[0]
          }
        }
      };
    }

    return state;
  },
  resetPassword: async (state: IStore, data: IResetPassword) => {
    const response = await request.post(api.resetPassword, data);

    if (response.error) {
      return {
        errors: {
          resetPassword: {
            msg: response.error.statusText[0]
          }
        }
      };
    }

    return state;
  }
};

export default actions;
